export const ActionTypes = {
  LOADING: "GET_G_LEVERAGE_SCORES_LOADING",
  ERROR: "GET_G_LEVERAGE_SCORES_ERROR",
  SUCCESS: "GET_G_LEVERAGE_SCORES_SUCCESS",

  UPDATE_LOADING: "UPDATE_G_LEVERAGE_SCORES_LOADING",
  UPDATE_ERROR: "UPDATE_G_LEVERAGE_SCORES_ERROR",
  UPDATE_SUCCESS: "UPDATE_G_LEVERAGE_SCORES_SUCCESS",
};
